<script lang="ts">
	import PhoneName from "./PhoneName.svelte";
	import type { Config } from "../types";

	$: width = 0;

	export let config: Config;
	const nameFormater = new Intl.ListFormat("no", {
		style: "long",
		type: "conjunction",
	});
</script>

<section bind:clientWidth={width} class="contactus">
	<div class="header">
		<h3>{config.title}</h3>
		{#if config.subtitle}
			<p>{config.subtitle}</p>
		{/if}
	</div>
	<div class="content">
		{#if config.text}
			<p>{config.text}</p>
		{/if}
		{#if config.viewPhone && config.viewEmail}
			<p>
				Kontakt {config.journalists.length === 1 &&
				config.journalists[0].name.split(" ")[0] !== "redaksjonen"
					? "meg"
					: "oss"} på
				<a href="mailto:{config.journalists.map((j) => j.email).join(',')}"
					>e-post</a
				>
				eller telefon til <PhoneName {width} journalists={config.journalists} />
			</p>
		{:else if config.viewPhone}
			<p>
				Kontakt {config.journalists.length === 1 ? "meg" : "oss"} på telefon til
				<PhoneName {width} journalists={config.journalists} />
			</p>
		{:else if config.viewEmail}
			<p>
				Kontakt {config.journalists.length === 1 ? "meg" : "oss"} på
				<a href="mailto:{config.journalists.map((j) => j.email).join(',')}"
					>e-post</a
				>.
			</p>
		{/if}
		{#if config.viewKryptert}
			<p class="kryptert-tips">
				🔒 Sensitiv informasjon? <a
					target="_blank"
					href="https://www.aftenbladet.no/securedrop/"
					>Send inn kryptert tips her.</a
				>
			</p>
		{/if}
	</div>
	<section class="journalists">
		<div class="image-row">
			{#if config.journalists.find((j) => j.image) && (config.viewImages == true || config.viewImages == undefined)}
				<div class="images">
					{#each config.journalists as journalist}
						{#if journalist.image}
							<img src={journalist.image} alt="" />
						{/if}
					{/each}
				</div>
			{/if}
			<div class="thanks">
				<h4>{config.thanks}</h4>
				<p>{nameFormater.format(config.journalists.map((j) => j.name))}</p>
			</div>
		</div>
	</section>
</section>

<style lang="scss">
	@font-face {
		font-family: "Inter";
		src: url("https://cdn.bt.no/rnd/fonts/Inter-Regular.otf") format("opentype"),
			url("https://cdn.bt.no/rnd/fonts/Inter-Regular.woff") format("woff"),
			url("https://cdn.bt.no/rnd/fonts/Inter-Regular.woff2") format("woff2");
		font-weight: 400;
		font-style: normal;
	}

	@font-face {
		font-family: "Inter";
		src: url("https://cdn.bt.no/rnd/fonts/Inter-Medium.otf") format("opentype"),
			url("https://cdn.bt.no/rnd/fonts/Inter-Medium.woff") format("woff"),
			url("https://cdn.bt.no/rnd/fonts/Inter-Medium.woff2") format("woff2");
		font-weight: 500;
		font-style: normal;
	}

	@font-face {
		font-family: "Inter";
		src: url("https://cdn.bt.no/rnd/fonts/Inter-SemiBold.otf")
				format("opentype"),
			url("https://cdn.bt.no/rnd/fonts/Inter-SemiBold.woff") format("woff"),
			url("https://cdn.bt.no/rnd/fonts/Inter-SemiBold.woff2") format("woff2");
		font-weight: 600;
		font-style: normal;
	}
	.contactus {
		font-family: Inter, Helvetica, Arial, sans-serif;
		background-color: #f5f5f5;
		padding: 20px;
		font-size: 16px;
		color: #000;
		border-radius: 6px;

		h4,
		p {
			margin: 0;
		}
		.header {
			margin-bottom: 20px;
			h3 {
				font-size: 24px;
				margin: 0;
			}
		}

		.content {
			margin-bottom: 1.2rem;
			p {
				margin-bottom: 0.5rem;
			}
			:global(a) {
				color: #000;
				text-decoration: underline;
			}
			.kryptert-tips {
				font-size: 0.8em;
			}
		}
		.journalists {
			margin-bottom: 20px;
			.image-row {
				display: flex;
				flex-direction: column;
				gap: 0;
				@media screen and (min-width: 512px) {
					gap: 16px;
					align-items: center;
					flex-direction: row;
					justify-content: flex-start;
				}

				.images {
					min-width: fit-content;

					img {
						height: 55px;
						width: 55px;
						object-fit: cover;
						object-position: center center;
						border-radius: 50rem;
						border: 2px solid #fff;
						@media screen and (min-width: 481px) {
							border: 3px solid #fff;
							height: 60px;
							width: 60px;
						}
						&:not(:first-child) {
							margin-left: -20px;
						}
					}
				}
				.thanks {
					margin-left: 8px;
					@media screen and (min-width: 512px) {
						margin-left: unset;
					}
					h4 {
						font-weight: 400;
					}
					p {
						font-weight: 500;
					}
				}
			}
		}
	}
</style>
